import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Typography } from '@material-ui/core';
import {
  Grid
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FormatInputNumero, SelectAsincronico, SelectFree, TextFieldAutoComplete } from 'components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },

}));
export default function FormularioIncidencia(props) {
  const { errors, setValue, watch, datoS } = props;
  const classes = useStyles();
  setValue('idsolicitud', datoS.idsolicitud);

  const handleChange = (event, value) => {
    if (value.length > 0) {
      setValue("responsables", value);
    } else setValue("responsables", null);
  };

  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const fechaActual = year + "-" + month + "-" + day;

  return (
    <Grid container className={classes.root} spacing={2}>

      <Grid item lg={12} xs={12}>
        <TextField
          value={watch('titulo')}
          onChange={(e) => setValue('titulo', e.target.value)}
          id="outlined-error-helper-text"
          label="TÍTULO"
          variant="outlined"
          fullWidth
          name="titulo"
          error={Boolean(errors.titulo)}
          helperText={errors.titulo}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          id="outlined-error-helper-text"
          label="EXTERNOS"
          variant="outlined"
          fullWidth
          name="involucrados"
          value={watch('involucrados')}
          onChange={(e) => setValue('involucrados', e.target.value)}
          error={Boolean(errors.involucrados)}
          helperText={errors.involucrados}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          id="outlined-error-helper-text"
          label="DESCRIPCIÓN"
          variant="outlined"
          fullWidth
          name="descripcion"
          value={watch('descripcion')}
          onChange={(e) => setValue('descripcion', e.target.value)}
          error={Boolean(errors.descripcion)}
          helperText={errors.descripcion}
        />
      </Grid>
      {/* <TextField
        error={false}
        // value={datoS.idsolicitud}
        // defaultValue={datoS.idsolicitud}
        style={{ display: "none" }}
        id="outlined-error-helper-text"
        label="IDSOLICITUD"
        variant="outlined"
        fullWidth
        name="idsolicitud"
      />
      <Grid item md={12} xs={12}>
        <TextField size="small"   error={errors.titulo != undefined} helperText={errors.titulo}  
        onChange={(e) => setValue('titulo', e.target.value)}
        variant="outlined" fullWidth label="TÍTULO" 
        name="titulo" 
        value={watch('titulo')}
         />
      </Grid>
      <Grid item lg={4} xs={4}>
        <TextField
          value={watch('fecha_inicio')}
          label="FECHA DE INICIO"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => setValue('fecha_inicio', e.target.value)}
          variant="outlined"
          fullWidth
          name="fecha_inicio"
          // InputProps={{ inputProps: { min: defaultItem.fecha_inicio ? defaultItem.fecha_inicio : fechamin , max: fechaActual } }}
          type="date"
          error={errors.fecha_inicio != undefined}
          helperText={errors.fecha_inicio}
        />
      </Grid>
      <Grid item lg={4} xs={4}>
        <TextField
          value={watch('fecha_termino')}
          label="FECHA DE TÉRMINO"
          variant="outlined"
          fullWidth
          name="fecha_termino"
          type="date"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => setValue('fecha_termino', e.target.value)}
          // InputProps={{ inputProps: { min: defaultItem.fecha_inicio ? defaultItem.fecha_inicio : fechamin , max: fechaActual } }}
          error={errors.fecha_termino != undefined}
          helperText={errors.fecha_termino}
        />
      </Grid>
      <Grid item lg={4} xs={4}>
        <TextField
          label="# HORAS TRABAJO"
          variant="outlined"
          fullWidth
          name="nhoras_seguimiento"
          type="number"
          value={watch('nhoras_seguimiento')}
          onChange={(e) => setValue('nhoras_seguimiento', e.target.value)}
          error={errors.nhoras_seguimiento != undefined}
          helperText={errors.nhoras_seguimiento}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <Autocomplete
          multiple
          options={datoS.equipo}
          getOptionLabel={(option) => option.nombre}
          getOptionSelected={(option, value) =>
            option.idpersona == value.idpersona
          }
          value={watch("responsables") || []}
          onChange={handleChange}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField
              label="MIEMBROS DEL EQUIPO"
              variant="outlined"
              {...params}
              error={errors.responsables != undefined}
              helperText={errors.responsables}
            />
          )}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          label="EXTERNOS"
          variant="outlined"
          fullWidth
          name="involucrados"
          value={watch('involucrados')}
          onChange={(e) => setValue('involucrados', e.target.value)}
          error={errors.involucrados != undefined}
          helperText={errors.involucrados}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          id="outlined-error-helper-text"
          label="OBSERVACIONES"
          variant="outlined"
          fullWidth
          name="observaciones"
          value={watch('observaciones')}
          onChange={(e) => setValue('observaciones', e.target.value)}
          error={errors.observaciones != undefined}
          helperText={errors.observaciones}
        />
      </Grid> */}
    </Grid>
  );
}
